<template>
  <div id="message">
    <div id="timer">
      <div v-if="timerShow" class="remainTime">
        <span id="minutes" v-if="days>0">{{ days }}</span>
        <span id="middle" v-if="days>0">:</span>
        <span id="minutes">{{ hours }}</span>
        <span id="middle">:</span>
        <span id="minutes">{{ minutes }}</span>
        <span id="middle">:</span>
        <span id="seconds">{{ seconds }}</span>
      </div>
      <div v-else class="timeUp">
        <span v-if="$route.name=='TvShop' || $route.name=='home'"> Live</span>
        <span v-else-if="$route.name=='BiddingDetail' || $route.name=='BiddingProductListing'"> {{$t('biddingOver')}}</span>
        <span v-else> Expired</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Timer",
  props: {
    timing: {
      required: true,
      type: Number
    },
    Index:{
        type:Number
    },
    GroupID:{
        type:String
    }
  },
  data() {
    return {
      timer: null,
      totalTime: this.timing,
      date: Math.trunc(new Date().getTime() / 1000),
      timerShow: true
    };
  },

  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.countdown();
      }, 1000);
    },

    padTime(time) {
      return (time < 10 ? "0" : "") + time;
    },

    countdown() {
      if (this.totalTime > this.date) {
        this.totalTime--;
      } else {
        this.timerShow = false;
        clearInterval(this.timer);
        let obj={index:this.Index,groupID:this.GroupID, timerShow: this.timerShow}
        this.$emit("StopTime",obj);
      }
    }
  },

  computed: {
    days: function() {
      const days = Math.trunc((this.totalTime - this.date) / 86400);
      return this.padTime(days);
    },
    hours: function() {
      const hours = Math.trunc((this.totalTime - this.date) / 3600) % 24;
      return this.padTime(hours);
    },
    minutes: function() {
      const minutes = Math.trunc((this.totalTime - this.date) / 60) % 60;
      return this.padTime(minutes);
    },
    seconds: function() {
      const seconds = Math.trunc(this.totalTime - this.date) % 60;
      return this.padTime(seconds);
    }
  },

  mounted() {
    this.startTimer();
  },

  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
